import { render, staticRenderFns } from "./link-activity.vue?vue&type=template&id=6acd4db9&scoped=true&"
import script from "./link-activity.vue?vue&type=script&lang=js&"
export * from "./link-activity.vue?vue&type=script&lang=js&"
import style0 from "./link-activity.vue?vue&type=style&index=0&id=6acd4db9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acd4db9",
  null
  
)

export default component.exports